import {
  defaultNumberFilter,
  defaultRelationFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  ComponentModelConfig,
  ComponentTypeConfig,
  ExternalSupplierConfig,
} from '@pigello/pigello-matrix';

const componentModelFilters: Filter[] = [
  {
    ...defaultRelationFilter,
    title: ComponentModelConfig.fields.componentType.verboseName,
    externalFieldName:
      ComponentModelConfig.fields.componentType.externalFieldName,
    relationModelName: ComponentTypeConfig.modelName,
  },
  {
    ...defaultRelationFilter,
    title: ComponentModelConfig.fields.responsibleExternalSupplier.verboseName,
    externalFieldName:
      ComponentModelConfig.fields.responsibleExternalSupplier.externalFieldName,
    relationModelName: ExternalSupplierConfig.modelName,
  },
  {
    ...defaultStringFilter,
    title: ComponentModelConfig.fields.name.verboseName,
    externalFieldName: ComponentModelConfig.fields.name.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: ComponentModelConfig.fields.articleNumber.verboseName,
    externalFieldName:
      ComponentModelConfig.fields.articleNumber.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ComponentModelConfig.fields.defaultPurchaseValue.verboseName,
    externalFieldName:
      ComponentModelConfig.fields.defaultPurchaseValue.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ComponentModelConfig.fields.warrantyMonths.verboseName,
    externalFieldName:
      ComponentModelConfig.fields.warrantyMonths.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: ComponentModelConfig.fields.supplierWebpage.verboseName,
    externalFieldName:
      ComponentModelConfig.fields.supplierWebpage.externalFieldName,
  },
  {
    ...defaultStringFilter,
    title: ComponentModelConfig.fields.make.verboseName,
    externalFieldName: ComponentModelConfig.fields.make.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ComponentModelConfig.fields.length.verboseName,
    externalFieldName: ComponentModelConfig.fields.length.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ComponentModelConfig.fields.width.verboseName,
    externalFieldName: ComponentModelConfig.fields.width.externalFieldName,
  },
  {
    ...defaultNumberFilter,
    title: ComponentModelConfig.fields.height.verboseName,
    externalFieldName: ComponentModelConfig.fields.height.externalFieldName,
  },
];

export default componentModelFilters;
